import { SVGProps } from 'react';

const WithDrawIcon = (props: SVGProps<SVGSVGElement>) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  (<svg
    width={15}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="WithDrawIcon">
    <path
      d="M1.167 13.667h11.958V9.584h1.167v4.667a.583.583 0 0 1-.584.583H.583A.583.583 0 0 1 0 14.251V9.584h1.167v4.083ZM7.583 2.233l3.541 3.542.825-.825L6.999 0 2.05 4.95l.826.825 3.541-3.54V8.75h1.167V2.233Z"
      fill="var(--brand-bg-primary)"
    />
  </svg>)
);

export default WithDrawIcon;
